module.exports = __webpack_public_path__ + "static/media/Text-To-Speech.d895d021.jpg";